/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 타입
 */
export type UserDictionaryEntryType = 'General' | 'Food' | 'Supplement' | 'Exercise';

export const UserDictionaryEntryType = {
    General: 'General' as UserDictionaryEntryType,
    Food: 'Food' as UserDictionaryEntryType,
    Supplement: 'Supplement' as UserDictionaryEntryType,
    Exercise: 'Exercise' as UserDictionaryEntryType
};

